import script from "./SupplierComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierComp.vue?vue&type=script&setup=true&lang=js"

import "./SupplierComp.vue?vue&type=style&index=0&id=4295b5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4295b5f2"]])

export default __exports__